import { OrderTemplateItemDto } from '@eurogast/hub-client-typescript';

export abstract class OrderTemplateItemDeserializer {
  public static parseOrderTemplateItem(orderTemplateItem: string): OrderTemplateItemDto {
    if (!orderTemplateItem) {
      return null;
    }

    const m: Map<string, string> = new Map<string, string>();
    orderTemplateItem.split(';;').forEach((s) => {
      const parts = s.split('::');
      m.set(parts[0], parts[1]);
    });
    return {
      productSku: m.get('productSku'),
      amount: Number(m.get('amount')),
      unit: m.get('unit'),
    };
  }


}
